export default __webpack_public_path__ + "static/media/Status_Off.5a7a7547.svg";